/**
 * Questionnaire v2 — Étape 16
 * Bottes de fleurs en supplément (navigation à 3 niveaux)
 */
(function () {
  'use strict';

  let initialized = false;
  let flowersData = null;
  const flowersVarietiesData = {};
  const flowersSubcategoriesData = {};
  const flowersCategoriesData = {};
  const flowersSelections = {};
  let currentCategoryName = null;
  let currentSubcategoryName = null;

  function getWeddingDateInput() {
    return document.getElementById('qv2-wedding-date');
  }

  function getWeddingMonth() {
    const weddingDateInput = getWeddingDateInput();
    if (!weddingDateInput || !weddingDateInput.value) return null;
    const match = weddingDateInput.value.match(/^\d{4}-(\d{2})-\d{2}$/);
    return match ? parseInt(match[1], 10) : null;
  }

  function isSubcategoryAvailable(subcategoryName, month) {
    if (!month) return true;
    const normalizedName = subcategoryName.toUpperCase().trim();
    if (normalizedName.includes('PIVOINE')) return month >= 4 && month <= 6;
    if (normalizedName.includes('TULIPE')) return month >= 1 && month <= 4;
    if (normalizedName.includes('RENONCULE')) return month >= 1 && month <= 3;
    return true;
  }

  function getVarietyDisplayName(variety) {
    if (!variety) return '';
    if (variety.displayName) return String(variety.displayName).trim();
    const parent = String(variety.subcategoryName || variety.categoryName || '').trim();
    const shortName = String(variety.name || '').trim();
    if (parent && shortName) return parent + ' — ' + shortName;
    return parent || shortName;
  }

  function loadFlowersData() {
    if (flowersData) return;
    const flowersDataScript = document.getElementById('flowers-varieties-data');
    if (!flowersDataScript) return;
    try {
      flowersData = JSON.parse(flowersDataScript.textContent);
      if (flowersData.varieties) {
        flowersData.varieties.forEach(function (variety) {
          variety.displayName = getVarietyDisplayName(variety);
          flowersVarietiesData[variety.id] = variety;
        });
      }
      if (flowersData.subcategories) {
        flowersData.subcategories.forEach(function (subcategory) {
          flowersSubcategoriesData[subcategory.id] = subcategory;
          flowersSubcategoriesData[subcategory.name] = subcategory;
        });
      }
      if (flowersData.categories) {
        flowersData.categories.forEach(function (category) {
          flowersCategoriesData[category.id] = category;
          flowersCategoriesData[category.name] = category;
        });
      }
    } catch (e) {
      console.error('[QV2] Erreur chargement données fleurs:', e);
    }
  }

  function hydrateStep16CategoryImages() {
    loadFlowersData();
    if (!flowersData || !flowersData.categories) return;

    flowersData.categories.forEach(function (category) {
      if (!category || !category.id) return;
      const option = document.querySelector('.flower-category-option[data-category-id="' + category.id + '"]');
      if (!option) return;

      if (category.name) {
        option.setAttribute('data-category-name', category.name);
        const nameEl = option.querySelector('.flower-category-name');
        if (nameEl && nameEl.textContent.trim() === 'Catégorie') {
          nameEl.textContent = category.name;
        }
      }

      if (!category.image) return;
      const iconWrap = option.querySelector('.flower-category-icon');
      if (!iconWrap) return;
      let img = iconWrap.querySelector('img');
      if (!img) {
        iconWrap.innerHTML = '';
        img = document.createElement('img');
        img.loading = 'eager';
        img.decoding = 'async';
        iconWrap.appendChild(img);
      }
      img.src = category.image;
      img.alt = category.name || '';
      img.setAttribute('data-fallback-src', category.image);
    });
  }

  function getVarietySelectionCount(categoryName, subcategoryName) {
    if (!flowersSelections[categoryName] || !flowersSelections[categoryName][subcategoryName]) return 0;
    let total = 0;
    Object.values(flowersSelections[categoryName][subcategoryName]).forEach(function (quantity) {
      total += quantity;
    });
    return total;
  }

  function getSubcategorySelectionCount(categoryName, subcategoryName) {
    return getVarietySelectionCount(categoryName, subcategoryName);
  }

  function getCategorySelectionCount(categoryName) {
    if (!flowersSelections[categoryName]) return 0;
    let total = 0;
    if (flowersSelections[categoryName].direct) {
      Object.values(flowersSelections[categoryName].direct).forEach(function (quantity) {
        total += quantity;
      });
    }
    Object.keys(flowersSelections[categoryName]).forEach(function (subcategoryName) {
      if (subcategoryName !== 'direct') {
        total += getSubcategorySelectionCount(categoryName, subcategoryName);
      }
    });
    return total;
  }

  function updateSelectionCounts() {
    document.querySelectorAll('.flower-category-option[data-category-id]').forEach(function (option) {
      const categoryName = option.getAttribute('data-category-name');
      const countEl = option.querySelector('.flower-category-count');
      if (!countEl || !categoryName) return;
      const count = getCategorySelectionCount(categoryName);
      if (count > 0) {
        countEl.textContent = count + (count > 1 ? ' sélectionnés' : ' sélectionné');
        option.classList.add('selected');
      } else {
        countEl.textContent = '0 sélectionné';
        option.classList.remove('selected');
      }
    });

    document.querySelectorAll('.flower-category-option[data-subcategory-id]').forEach(function (option) {
      const subcategoryName = option.getAttribute('data-subcategory-name');
      const countEl = option.querySelector('.flower-category-count');
      if (!countEl || !subcategoryName || !currentCategoryName) return;
      const count = getSubcategorySelectionCount(currentCategoryName, subcategoryName);
      if (count > 0) {
        countEl.textContent = count + (count > 1 ? ' sélectionnés' : ' sélectionné');
        option.classList.add('selected');
      } else {
        countEl.textContent = '0 sélectionné';
        option.classList.remove('selected');
      }
    });
  }

  function updateStep16Validation() {
    const validateStep16 = document.getElementById('validate-step-16');
    const noFlowersBtn = document.getElementById('no-flowers-btn');
    if (!validateStep16) return;
    const noFlowersSelected = noFlowersBtn && noFlowersBtn.classList.contains('selected');
    const hasSelections = Object.keys(flowersSelections).length > 0 &&
      Object.values(flowersSelections).some(function (category) {
        return Object.values(category).some(function (subcat) {
          return Object.keys(subcat).length > 0;
        });
      });
    validateStep16.disabled = !(noFlowersSelected || hasSelections);
  }

  function getVarietyImages(variety) {
    const images = [];
    if (variety.image) images.push(variety.image);
    if (variety.image_1) images.push(variety.image_1);
    if (variety.image_2) images.push(variety.image_2);
    if (variety.image_3) images.push(variety.image_3);
    if (variety.image_4) images.push(variety.image_4);
    return images;
  }

  function buildVarietyImageHTML(varietyLabel, images) {
    if (images.length > 1) {
      return (
        '<div class="flower-variety-image-swiper-container">' +
          '<div class="swiper flower-variety-swiper">' +
            '<div class="swiper-wrapper">' +
              images.map(function (img) {
                return '<div class="swiper-slide"><img src="' + img + '" alt="' + varietyLabel + '" loading="eager" decoding="async" data-fallback-src="' + img + '"></div>';
              }).join('') +
            '</div>' +
            '<div class="swiper-button-next flower-variety-swiper-next"></div>' +
            '<div class="swiper-button-prev flower-variety-swiper-prev"></div>' +
            '<div class="swiper-pagination flower-variety-swiper-pagination"></div>' +
          '</div>' +
        '</div>'
      );
    }
    if (images.length === 1) {
      return '<div class="flower-variety-image"><img src="' + images[0] + '" alt="' + varietyLabel + '" loading="eager" decoding="async" data-fallback-src="' + images[0] + '"></div>';
    }
    return '';
  }

  function initVarietySwiper(varietyItem, images) {
    if (images.length <= 1 || typeof Swiper === 'undefined') return;
    const swiperContainer = varietyItem.querySelector('.flower-variety-swiper');
    if (!swiperContainer) return;
    new Swiper(swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      navigation: {
        nextEl: varietyItem.querySelector('.flower-variety-swiper-next'),
        prevEl: varietyItem.querySelector('.flower-variety-swiper-prev')
      },
      pagination: {
        el: varietyItem.querySelector('.flower-variety-swiper-pagination'),
        clickable: true
      }
    });
  }

  function setVarietyQuantity(categoryName, subcategoryKey, varietyId, quantity) {
    if (!flowersSelections[categoryName]) flowersSelections[categoryName] = {};
    if (!flowersSelections[categoryName][subcategoryKey]) flowersSelections[categoryName][subcategoryKey] = {};
    if (quantity > 0) {
      flowersSelections[categoryName][subcategoryKey][varietyId] = quantity;
    } else {
      delete flowersSelections[categoryName][subcategoryKey][varietyId];
      if (Object.keys(flowersSelections[categoryName][subcategoryKey]).length === 0) {
        delete flowersSelections[categoryName][subcategoryKey];
      }
      if (Object.keys(flowersSelections[categoryName]).length === 0) {
        delete flowersSelections[categoryName];
      }
    }
  }

  function getVarietyCurrentQuantity(categoryName, subcategoryKey, varietyId) {
    return flowersSelections[categoryName] &&
      flowersSelections[categoryName][subcategoryKey] &&
      flowersSelections[categoryName][subcategoryKey][varietyId]
      ? flowersSelections[categoryName][subcategoryKey][varietyId]
      : 0;
  }

  function bindVarietyItemEvents(varietyItem, varietyId, categoryName, subcategoryKey) {
    const noFlowersBtn = document.getElementById('no-flowers-btn');

    varietyItem.addEventListener('click', function (e) {
      if (e.target.closest('.flower-variety-bundles-btn, .flower-variety-swiper-next, .flower-variety-swiper-prev, .swiper-pagination, .image-zoom-btn')) {
        return;
      }
      const quantityEl = document.getElementById('variety-quantity-' + varietyId);
      if (!quantityEl) return;
      const currentValue = parseInt(quantityEl.textContent, 10) || 0;
      if (currentValue === 0) {
        quantityEl.textContent = '1';
        if (noFlowersBtn) noFlowersBtn.classList.remove('selected');
        setVarietyQuantity(categoryName, subcategoryKey, varietyId, 1);
        this.classList.add('selected');
      } else {
        quantityEl.textContent = '0';
        setVarietyQuantity(categoryName, subcategoryKey, varietyId, 0);
        this.classList.remove('selected');
      }
      updateSelectionCounts();
      updateStep16Validation();
    });

    varietyItem.querySelectorAll('.variety-bundle-minus, .variety-bundle-plus').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        const quantityEl = document.getElementById('variety-quantity-' + varietyId);
        if (!quantityEl) return;
        let currentValue = parseInt(quantityEl.textContent, 10) || 0;
        if (this.classList.contains('variety-bundle-minus')) {
          if (currentValue > 0) currentValue--;
        } else {
          currentValue++;
        }
        quantityEl.textContent = String(currentValue);
        if (currentValue > 0 && noFlowersBtn) noFlowersBtn.classList.remove('selected');
        setVarietyQuantity(categoryName, subcategoryKey, varietyId, currentValue);
        varietyItem.classList.toggle('selected', currentValue > 0);
        updateSelectionCounts();
        updateStep16Validation();
      });
    });
  }

  function renderVarietyItem(varietyId, index, categoryName, subcategoryKey) {
    const variety = flowersVarietiesData[varietyId];
    if (!variety) return null;
    const varietyLabel = getVarietyDisplayName(variety);
    const currentQuantity = getVarietyCurrentQuantity(categoryName, subcategoryKey, varietyId);
    const images = getVarietyImages(variety);
    const zoomImageUrl = images.length > 0 ? images[0] : '';

    const varietyItem = document.createElement('div');
    varietyItem.className = 'flower-variety-item' +
      (currentQuantity > 0 ? ' selected' : '') +
      (index >= 4 ? ' flower-variety-hidden' : '');
    varietyItem.setAttribute('data-variety-id', varietyId);
    varietyItem.innerHTML =
      '<div class="flower-variety-image-wrapper">' +
        buildVarietyImageHTML(varietyLabel, images) +
        (zoomImageUrl
          ? '<button class="image-zoom-btn" data-lightbox-src="' + zoomImageUrl + '" aria-label="Agrandir l\'image">' +
              '<svg class="svg-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                '<circle cx="11" cy="11" r="7"></circle>' +
                '<line x1="16.65" y1="16.65" x2="21" y2="21"></line>' +
              '</svg>' +
            '</button>'
          : '') +
        '<div class="flower-variety-overlay">' +
          '<svg class="svg-icon" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
            '<polyline points="20 6 9 17 4 12"></polyline>' +
          '</svg>' +
        '</div>' +
      '</div>' +
      '<div class="flower-variety-name">' + varietyLabel + '</div>' +
      '<div class="flower-variety-price">' + variety.price + ' €</div>' +
      '<div class="flower-variety-quantity-info">' + variety.quantityPerBundle + ' fleurs par botte</div>' +
      '<div class="flower-variety-bundles-selector">' +
        '<span class="flower-variety-bundles-label">Nombre de bottes :</span>' +
        '<div class="flower-variety-bundles-controls">' +
          '<button type="button" class="flower-variety-bundles-btn variety-bundle-minus" data-variety-id="' + varietyId + '">-</button>' +
          '<span class="flower-variety-bundles-value" id="variety-quantity-' + varietyId + '">' + currentQuantity + '</span>' +
          '<button type="button" class="flower-variety-bundles-btn variety-bundle-plus" data-variety-id="' + varietyId + '">+</button>' +
        '</div>' +
      '</div>';

    initVarietySwiper(varietyItem, images);
    bindVarietyItemEvents(varietyItem, varietyId, categoryName, subcategoryKey);
    return varietyItem;
  }

  function showVarietiesView(categoryName, subcategoryKey, title, varietyIds) {
    const flowersCategoriesView = document.getElementById('flowers-categories-view');
    const flowersSubcategoriesView = document.getElementById('flowers-subcategories-view');
    const flowersVarietiesView = document.getElementById('flowers-varieties-view');
    const flowersVarietiesTitle = document.getElementById('flowers-varieties-title');
    const flowersVarietiesList = document.getElementById('flowers-varieties-list');

    if (flowersVarietiesTitle) flowersVarietiesTitle.textContent = title;
    if (!flowersVarietiesList) return;

    flowersVarietiesList.innerHTML = '';
    const existingSeeMore = flowersVarietiesView && flowersVarietiesView.querySelector('.questionnaire-see-more');
    if (existingSeeMore) existingSeeMore.remove();

    varietyIds.forEach(function (varietyId, index) {
      const item = renderVarietyItem(varietyId, index, categoryName, subcategoryKey);
      if (item) flowersVarietiesList.appendChild(item);
    });

    if (varietyIds.length > 3 && flowersVarietiesView) {
      const seeMoreContainer = document.createElement('div');
      seeMoreContainer.className = 'questionnaire-see-more';
      seeMoreContainer.innerHTML = '<a href="#" class="see-more-link" id="flowers-varieties-see-more">VOIR PLUS</a>';
      flowersVarietiesView.appendChild(seeMoreContainer);
    }

    if (flowersCategoriesView) flowersCategoriesView.style.display = 'none';
    if (flowersSubcategoriesView) flowersSubcategoriesView.style.display = 'none';
    if (flowersVarietiesView) flowersVarietiesView.style.display = 'block';
  }

  function showVarietiesForSubcategory(subcategoryId) {
    const subcategory = flowersSubcategoriesData[subcategoryId];
    if (!subcategory) return;
    currentSubcategoryName = subcategory.name;
    const varietyIds = Object.keys(flowersVarietiesData).filter(function (varietyId) {
      return flowersVarietiesData[varietyId].subcategoryName === subcategory.name;
    });
    showVarietiesView(currentCategoryName, subcategory.name, subcategory.name, varietyIds);
  }

  function showVarietiesForCategory(categoryId) {
    const category = flowersCategoriesData[categoryId];
    if (!category) return;
    currentCategoryName = category.name;
    currentSubcategoryName = null;
    const varietyIds = Object.keys(flowersVarietiesData).filter(function (varietyId) {
      const variety = flowersVarietiesData[varietyId];
      return variety.categoryName === category.name && (!variety.subcategoryName || variety.subcategoryName === '');
    });
    showVarietiesView(category.name, 'direct', category.name, varietyIds);
  }

  function updateSubcategoriesAvailability() {
    const flowersSubcategoriesList = document.getElementById('flowers-subcategories-list');
    if (!flowersSubcategoriesList) return;
    const weddingMonth = getWeddingMonth();
    flowersSubcategoriesList.querySelectorAll('.flower-category-option[data-subcategory-name]').forEach(function (item) {
      const subcategoryName = item.getAttribute('data-subcategory-name');
      const isAvailable = isSubcategoryAvailable(subcategoryName, weddingMonth);
      const subcategoryId = item.getAttribute('data-subcategory-id');
      if (isAvailable) {
        item.classList.remove('disabled', 'unavailable');
        item.style.cursor = 'pointer';
        item.style.pointerEvents = 'auto';
        const badge = item.querySelector('.unavailable-badge');
        if (badge) badge.remove();
        item.onclick = function () { showVarietiesForSubcategory(subcategoryId); };
      } else {
        item.classList.add('disabled', 'unavailable');
        item.style.cursor = 'not-allowed';
        item.style.pointerEvents = 'none';
        if (!item.querySelector('.unavailable-badge')) {
          const badge = document.createElement('div');
          badge.className = 'unavailable-badge';
          badge.textContent = 'Non disponible cette saison';
          item.style.position = 'relative';
          item.appendChild(badge);
        }
        item.onclick = function (e) {
          e.preventDefault();
          e.stopPropagation();
        };
      }
    });
  }

  function showSubcategoriesForCategory(categoryId) {
    const category = flowersCategoriesData[categoryId];
    if (!category) return;

    const flowersCategoriesView = document.getElementById('flowers-categories-view');
    const flowersSubcategoriesView = document.getElementById('flowers-subcategories-view');
    const flowersVarietiesView = document.getElementById('flowers-varieties-view');
    const flowersSubcategoriesTitle = document.getElementById('flowers-subcategories-title');
    const flowersSubcategoriesList = document.getElementById('flowers-subcategories-list');

    currentCategoryName = category.name;
    if (flowersSubcategoriesTitle) flowersSubcategoriesTitle.textContent = category.name;

    const subcategoriesForCategory = flowersData && flowersData.subcategories
      ? flowersData.subcategories
          .filter(function (subcategory) { return subcategory.categoryName === category.name; })
          .map(function (subcategory) { return subcategory.id; })
      : [];

    if (flowersSubcategoriesList) {
      flowersSubcategoriesList.innerHTML = '';
      const existingSeeMore = flowersSubcategoriesView && flowersSubcategoriesView.querySelector('.questionnaire-see-more');
      if (existingSeeMore) existingSeeMore.remove();

      subcategoriesForCategory.forEach(function (subcategoryId, index) {
        const subcategory = flowersSubcategoriesData[subcategoryId];
        if (!subcategory) return;
        const subcategoryName = subcategory.name;
        const count = getSubcategorySelectionCount(category.name, subcategoryName);
        const weddingMonth = getWeddingMonth();
        const isAvailable = isSubcategoryAvailable(subcategoryName, weddingMonth);

        const subcategoryItem = document.createElement('div');
        let itemClasses = 'flower-category-option';
        if (count > 0) itemClasses += ' selected';
        if (index >= 3) itemClasses += ' flower-subcategory-hidden';
        if (!isAvailable) itemClasses += ' disabled unavailable';
        subcategoryItem.className = itemClasses;
        subcategoryItem.setAttribute('data-subcategory-id', subcategoryId);
        subcategoryItem.setAttribute('data-subcategory-name', subcategoryName);
        subcategoryItem.innerHTML =
          (subcategory.image
            ? '<div class="flower-category-icon"><img src="' + subcategory.image + '" alt="' + subcategoryName + '" loading="eager" decoding="async" data-fallback-src="' + subcategory.image + '"' + (!isAvailable ? ' style="opacity: 0.5;"' : '') + '></div>'
            : '<div class="flower-category-icon"><svg class="svg-icon" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2L2 7l10 5 10-5-10-5z"></path><path d="M2 17l10 5 10-5"></path><path d="M2 12l10 5 10-5"></path></svg></div>') +
          '<div class="flower-category-name">' + subcategoryName + '</div>' +
          '<div class="flower-category-arrow"><svg class="svg-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg></div>' +
          '<div class="flower-category-count">' + (count > 0 ? count + (count > 1 ? ' sélectionnés' : ' sélectionné') : '0 sélectionné') + '</div>' +
          (!isAvailable ? '<div class="unavailable-badge">Non disponible cette saison</div>' : '');

        if (isAvailable) {
          subcategoryItem.addEventListener('click', function () {
            showVarietiesForSubcategory(subcategoryId);
          });
        } else {
          subcategoryItem.style.cursor = 'not-allowed';
          subcategoryItem.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
          });
        }
        flowersSubcategoriesList.appendChild(subcategoryItem);
      });

      if (subcategoriesForCategory.length > 3 && flowersSubcategoriesView) {
        const seeMoreContainer = document.createElement('div');
        seeMoreContainer.className = 'questionnaire-see-more';
        seeMoreContainer.innerHTML = '<a href="#" class="see-more-link" id="flowers-subcategories-see-more">VOIR PLUS</a>';
        flowersSubcategoriesView.appendChild(seeMoreContainer);
      }
    }

    if (flowersCategoriesView) flowersCategoriesView.style.display = 'none';
    if (flowersSubcategoriesView) flowersSubcategoriesView.style.display = 'block';
    if (flowersVarietiesView) flowersVarietiesView.style.display = 'none';

    setTimeout(updateSubcategoriesAvailability, 50);
  }

  function showSubcategoriesView() {
    const flowersCategoriesView = document.getElementById('flowers-categories-view');
    const flowersSubcategoriesView = document.getElementById('flowers-subcategories-view');
    const flowersVarietiesView = document.getElementById('flowers-varieties-view');
    if (flowersCategoriesView) flowersCategoriesView.style.display = 'none';
    if (flowersSubcategoriesView) flowersSubcategoriesView.style.display = 'block';
    if (flowersVarietiesView) flowersVarietiesView.style.display = 'none';
    currentSubcategoryName = null;
    updateSelectionCounts();
  }

  function showCategoriesView() {
    const flowersCategoriesView = document.getElementById('flowers-categories-view');
    const flowersSubcategoriesView = document.getElementById('flowers-subcategories-view');
    const flowersVarietiesView = document.getElementById('flowers-varieties-view');
    if (flowersCategoriesView) flowersCategoriesView.style.display = 'block';
    if (flowersSubcategoriesView) flowersSubcategoriesView.style.display = 'none';
    if (flowersVarietiesView) flowersVarietiesView.style.display = 'none';
    currentCategoryName = null;
    currentSubcategoryName = null;
    updateSelectionCounts();
  }

  function initSeeMoreLinks() {
    if (document.body.dataset.qv2FlowersSeeMore) return;
    document.body.dataset.qv2FlowersSeeMore = '1';

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.id) return;
      if (e.target.id === 'flowers-categories-see-more') {
        e.preventDefault();
        const grid = document.querySelector('.questionnaire-flowers-categories-grid');
        if (!grid) return;
        const isExpanded = grid.classList.contains('show-all');
        grid.classList.toggle('show-all', !isExpanded);
        e.target.textContent = isExpanded ? 'VOIR PLUS' : 'VOIR MOINS';
      }
      if (e.target.id === 'flowers-subcategories-see-more') {
        e.preventDefault();
        const grid = document.querySelector('.questionnaire-flowers-subcategories-grid');
        if (!grid) return;
        const isExpanded = grid.classList.contains('show-all');
        grid.classList.toggle('show-all', !isExpanded);
        e.target.textContent = isExpanded ? 'VOIR PLUS' : 'VOIR MOINS';
      }
      if (e.target.id === 'flowers-varieties-see-more') {
        e.preventDefault();
        const list = document.querySelector('.questionnaire-flowers-varieties-list');
        if (!list) return;
        const isExpanded = list.classList.contains('show-all');
        list.classList.toggle('show-all', !isExpanded);
        e.target.textContent = isExpanded ? 'VOIR PLUS' : 'VOIR MOINS';
      }
    });
  }

  function initStep16() {
    if (!document.querySelector('[data-qv2-section="16"]') &&
        !document.getElementById('validate-step-16') &&
        !document.getElementById('flowers-varieties-data')) {
      return;
    }

    loadFlowersData();
    initSeeMoreLinks();

    const flowersBackToCategoriesBtn = document.getElementById('flowers-back-to-categories-btn');
    const flowersBackToSubcategoriesBtn = document.getElementById('flowers-back-to-subcategories-btn');
    const noFlowersBtn = document.getElementById('no-flowers-btn');
    const weddingDateInput = getWeddingDateInput();

    if (flowersBackToCategoriesBtn && !flowersBackToCategoriesBtn.dataset.qv2Bound) {
      flowersBackToCategoriesBtn.dataset.qv2Bound = '1';
      flowersBackToCategoriesBtn.addEventListener('click', showCategoriesView);
    }

    if (flowersBackToSubcategoriesBtn && !flowersBackToSubcategoriesBtn.dataset.qv2Bound) {
      flowersBackToSubcategoriesBtn.dataset.qv2Bound = '1';
      flowersBackToSubcategoriesBtn.addEventListener('click', function () {
        if (currentSubcategoryName === null && currentCategoryName !== null) {
          showCategoriesView();
        } else {
          showSubcategoriesView();
        }
      });
    }

    document.querySelectorAll('.flower-category-option[data-category-id]').forEach(function (option) {
      if (option.dataset.qv2Bound) return;
      option.dataset.qv2Bound = '1';
      option.addEventListener('click', function () {
        const categoryId = this.getAttribute('data-category-id');
        const hasSubcategories = this.getAttribute('data-has-subcategories');
        if (!categoryId) return;
        if (hasSubcategories === 'yes') {
          showSubcategoriesForCategory(categoryId);
        } else {
          showVarietiesForCategory(categoryId);
        }
      });
    });

    if (noFlowersBtn && !noFlowersBtn.dataset.qv2Bound) {
      noFlowersBtn.dataset.qv2Bound = '1';
      noFlowersBtn.addEventListener('click', function () {
        Object.keys(flowersSelections).forEach(function (categoryName) {
          delete flowersSelections[categoryName];
        });
        this.classList.toggle('selected');
        updateSelectionCounts();
        updateStep16Validation();
      });
    }

    if (weddingDateInput && !weddingDateInput.dataset.qv2FlowersSeasonBound) {
      weddingDateInput.dataset.qv2FlowersSeasonBound = '1';
      weddingDateInput.addEventListener('change', function () {
        const flowersSubcategoriesView = document.getElementById('flowers-subcategories-view');
        if (flowersSubcategoriesView && flowersSubcategoriesView.style.display !== 'none') {
          updateSubcategoriesAvailability();
        }
      });
      weddingDateInput.addEventListener('input', function () {
        const flowersSubcategoriesView = document.getElementById('flowers-subcategories-view');
        if (flowersSubcategoriesView && flowersSubcategoriesView.style.display !== 'none') {
          updateSubcategoriesAvailability();
        }
      });
    }

    updateSelectionCounts();
    updateStep16Validation();
    initialized = true;
  }

  function getFlowerBundlesForSummary() {
    loadFlowersData();
    const bundles = [];
    Object.keys(flowersSelections).forEach(function (categoryName) {
      Object.keys(flowersSelections[categoryName]).forEach(function (subcategoryKey) {
        Object.keys(flowersSelections[categoryName][subcategoryKey]).forEach(function (varietyId) {
          const qty = flowersSelections[categoryName][subcategoryKey][varietyId];
          if (!qty || qty <= 0) return;
          const variety = flowersVarietiesData[varietyId];
          const title = variety ? getVarietyDisplayName(variety) : 'Botte de fleurs';
          const images = variety ? getVarietyImages(variety) : [];
          bundles.push({
            title: title,
            quantity: qty,
            image: images.length ? images[0] : '',
            varietyId: varietyId,
            price: variety ? variety.price : ''
          });
        });
      });
    });
    return bundles;
  }

  function onStepShown(stepNumber) {
    if (stepNumber === 16) {
      flowersData = null;
      initStep16();
      hydrateStep16CategoryImages();
      updateSelectionCounts();
      setTimeout(hydrateStep16CategoryImages, 150);
    }
  }

  window.QV2_STEPS_16 = {
    init: initStep16,
    onStepShown: onStepShown,
    updateSubcategoriesAvailability: updateSubcategoriesAvailability,
    getFlowerBundlesForSummary: getFlowerBundlesForSummary
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStep16);
  } else {
    initStep16();
  }
})();
